var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg123Milhas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F05929;}\n\t.st1{fill:#FFB727;}\n\t.st2{fill:#00AD46;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,74.2H11.9V36.2H1.2v-9.7h20.9V74.2L22.1,74.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,66.8l15.7-15.2c5.2-4.9,7.6-7.1,7.6-10.9c0-3.3-2.9-5.7-6.7-5.7c-4.8,0-7.3,3.5-7.1,8.7H26.6 c-0.5-11,7.1-18.7,17.7-18.7c10,0,17.1,6.4,17.1,15.3c0,6.6-4.4,11.8-10.9,17.7l-6.2,6.1h17.2v10H27.4v-7.3H27.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.9,36.2h-19v-9.6h33.4v6.6L86.9,44.8c6.8,0.6,11.9,6.3,11.9,13.7c0,9.6-7.5,16.4-17.7,16.4 c-9.6,0-16.8-6.1-17.5-14.8h10.2c0.5,2.7,3,4.9,7.2,4.9c4.3,0,7.3-2.9,7.3-6.8c0-5.7-6.6-7.7-13.5-5.7v-6.4L83.9,36.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg123Milhas);
export default __webpack_public_path__ + "static/media/123milhas.1ec8122b4eff732b884a8d522a17d360.svg";
export { ForwardRef as ReactComponent };